import { localizedText, getLocale } from '../../common-js/LanguageMap';
import { filterItemsByTags, filterItemsByTagsAndSearchQuery } from '../../common-js/DynamicData';

export default function ($scope, $state, $log, $timeout, addonFactory, DrawpService) {
    $scope.localizedText = localizedText;
    $scope.localizedTextSuffix = getLocale() === 'es' ? '_es' : '';

    $scope.stateTitle = $scope.localizedText('FILL_IN_THE_BLANK_FRAMES');
    $scope.stateSubtitle = $scope.localizedText('3_LEVELS');
    $scope.backState = 'addonAppIndex';
    $scope.stateClass = 'fitb3-item';
    $scope.toolId = '6603b1a1e4b0f12b1a345679';

    $scope.slideDialogData = {
        type: '',
        audio: '',
        value: ''
    };

    let serverUrl = 'https://app.drawpforschool.com/';
    let presentationId;

    $scope.error = null;
    const progressText = $scope.localizedText('LOADING');
    $scope.progress = progressText;
    $scope.enableReload = true;

    const ERROR_MESSAGE = addonFactory.API_CALL_ERROR.GENERICERROR;

    let elInputSearch = null;
    let elAreaOfFocus = null;
    let elLangProficiency = null;
    $scope.elBloomsLevel = null;
    // let elAudio = null;
    let elLanguage = null;

    let alertDialog = null;
    let subscriptionInfoDialog = null;
    let elementCancelSub = null;

    $scope.dokLabels = [$scope.localizedText('REMEMBERING_LEVEL_1'), $scope.localizedText('UNDERSTANDING_LEVEL_2'), $scope.localizedText('APPLYING_LEVEL_2'), $scope.localizedText('ANALYZING_LEVEL_3'), $scope.localizedText('EVALUATING_LEVEL_3'), $scope.localizedText('CREATING_LEVEL_4')];
    $scope.nameOfTheTool = '';
    $scope.userEmail = '';
    $scope.serverToken = '';
    $scope.language = 'en';
    $scope.audio = true;
    $scope.audioToolTip = false;
    $scope.subscription_days = 100;
    $scope.subscription = null;
    $scope.alertMultiAccount = false;
    $scope.expanded = true;
    $scope.loginDialogMessage = '';
    $scope.isLoginDialogOpen = false;

    $scope.bundleId = '';
    $scope.questionsId = '';
    $scope.sentenceFrameId = '';
    $scope.formData = null;

    $scope.currentQueryData = {
        dok: '',
        langProf: '',
        elaEldStandard: ''
    };

    $scope.searchData = null;
    $scope.searchQuery = '';
    $scope.searchErrorMessage = '';
    $scope.searchResultsQuestionIds = [];
    $scope.searchResultsSentenceIds = [];

    $scope.currentQuestionSet = null;
    $scope.currentSentenceSet = null;

    $scope.isNavCollapseableHidden = false;
    $scope.isQuestionListActive = true;
    $scope.isProductStrategyCollapsed = false;

    $scope.loadingMessage = progressText;
    $scope.unSortedDokList = [];
    $scope.disabledDokList = [];
    $scope.unSortedLangProfList = [];
    $scope.unSortedELAELDStandardsList = [];

    $scope.questionList = [];
    $scope.sentenceList = [];
    $scope.strategyList = [];
    $scope.productList = [];

    $scope.isSearchFilteringRunning = false;

    const emergingStrategy = {
        '577d6906e21552000a000005': [
            'Teacher modeling, with careful attention to validate cultural and linguistic knowledge, as a basis for student-designed constructions/drawings of concepts',
            'Role Playing with audio and written script',
            'You are the Teacher Poster',
            'Model how to: write a Literary Analysis that is scaffolded with a paragraph frame',
            'Students use sticky notes or tabs, or high lighter tape to mark their texts',
            'Write key vocabulary on the board to help students incorporate these words into their summaries',
            'Lengthen sentence frames to Paragraph frames',
        ],
        '577d68ff1f3023000b000000': [
            'Split Page Note Taking, with simplified text, working in pairs or groups',
            'Stand Up-Sit Down',
            'Graphic Organizers, with simplified text',
            'Inside-Outside Circle, to debate points',
            'Short Story Flow Chart, with simplified text or video',
            'Numbered Heads Together',
            'Learning Logs – double entry journals with quotes, summaries, notes on the left and responses, predictions, questions, or memories on the right',
            'Reading with Partners',
        ],
        '577d68f6378fe5000b000003': [
            'Sorting and classifying',
            'DRTA, with simplified text',
            'SQP2RS with simplified text',
            'Use high lighters in text - key elements',
            'QAR, Author and Me, with simplified texts and guided/framed answers in mixed-level cooperative groups',
            'Adapted Venn Diagram, in pairs or groups',
            'Inside-Outside Circle, with sentence frames',
            'Gallery Walk, to debrief comparisons',
            'Plot Chart, with simplified text or video',
            'Discussion Web - an opportunity to interact',
            'Teacher Modeling',
            'Concept Wheel for vocabulary',
        ],
        '577d6069378fe5000a000008': [
            'Drawing visual or symbolic representations of vocabulary or concepts',
            'Construction of models (e.g. using clay to sculpt layers of the earth’s crust)',
            'Simple sentence frames with a word chart or vocabulary list',
            '4-Corners Vocabulary with guidance',
            'Vocabulary Cards and Flip Books',
            'Framed Outline',
            'T-Chart',
            'Theatre Performances',
            'Puppetry',
            'Pair Share with partner',
            'Scaffolded and rehearsed presentations/role playing',
            'Quick Write (in primary/home language L1)',
            'Signal Word Posters',
            'Practice, practice, practice!',
        ],
        '5755c5fd2339f80009000000': [
            'Supplementary materials in primary/home language (L1)',
            'Videos, realia, visuals, demonstrations, Total Physical Response (TPR)',
            'Bilingual dictionaries use',
            'Time lines',
            'Scaffold graphic organizers',
            'Highlighting key points in a simplified text',
            'Word walls',
            'Taped Texts of simplified texts',
            'Go-Fish',
            'White Board',
            'Group work with explicit modeling',
            'Peer teaching',
            'Paraphrasing in student’s primary language',
            'Multi-level texts, matched to reading level',
        ],
        '5755c5f62127240009000003': [
            'Field trips to teach unfamiliar topics or concepts',
            'Bingo',
            'Primary/home language (L1) buddies',
            'Predictable and patterned books, with careful attention to validate cultural and linguistic knowledge',
            'Labeling drawings or diagrams',
            'Contextualized Cloze Sentences',
            'Instruction in survival, content-critical, and sight word vocabulary',
            'Illustrated KWL Chart',
            'Pretest in L1 or with a partner',
            'Book Walk with a text and adult guidance',
            'Cognates to learn vocabulary',
            'Question-Answer-Response',
            'Cloze paragraphs with vocabulary banks',
        ],
    };

    const expandingStrategy = {
        '577d6906e21552000a000005': [
            'Multiple models, with careful attention to validate cultural and linguistic knowledge, as a basis for student-designed constructions/drawings of concepts',
            'Role Playing with written scripts',
            'Ask to Create a new product. Give it a name and plan a marketing campaign using key vocabulary',
            'Partner Think Aloud/Read Aloud',
            'Progressive Maps – encourage students to visually organize old and new information. These maps are brought out again and again',
            'Visual representations of key vocabulary and concepts connect to students’ cultural and linguistic background',
        ],
        '577d68ff1f3023000b000000': [
            'Split Page Note Taking with simplified text, working in pairs or groups',
            'Fishbone graphic organizers',
            'Three Step Interview',
            '4 Corners',
            'Chunking and Questioning Aloud (CQA) process of reading a story aloud and stopping after certain blocks of text to ask specific questions about their comprehension of the story',
            'DRTA – Direct Reading and Thinking Aloud',
            'Literature Circles',
            'Teacher models and explicitly teaches thinking strategies such as: imagine, remember, think of a question, predict, pretend, recall, listen, look, think about, visualize, summarize, infer',
        ],
        '577d68f6378fe5000b000003': [
            'DRTA, with minimal support',
            'SQP2RS',
            'Canned Questions',
            'QAR, with simplified texts and guided/framed answers',
            'Venn Diagram, in pairs or groups',
            'Inside-Outside Circle (unstructured)',
            'Gallery Walk',
            'Plot Chart, with text or video',
            'Short Story Flow Chart, with simplified text or video',
            'Numbered Heads Together',
            'Reciprocal Teaching',
            'Preview checklist',
        ],
        '577d6069378fe5000a000008': [
            'Explicit grammar instruction to address non- transferable grammar issues',
            'Academic Journals',
            'Think and Search, with grade-level texts',
            'Send a Problem – Each student on a team makes up a review question and writes it on a 3x5 card. The writer asks the question of the other members team. When everyone agrees on an answer it is written on the back of the card. The teams then send their review questions to another team',
            'Three Step Interview',
            'Reciprocal Teaching',
            'Reading Circles/Book Club',
            'Quick Write',
            'Pass the Picture and write-on to story',
            'Round Table/Round Table',
            'Think aloud',
            'Collaborative Practice',
        ],
        '5755c5fd2339f80009000000': [
            'Adapted materials: picture books/simplified readings to teach key concepts, with careful attention to validate cultural and linguistic knowledge',
            'Note-taking guides and Jigsaw/Expert Groups to scaffold grade-level readings',
            'Completion of graphic organizers during or after a reading/video/lecture',
            'Highlighting key points in a grade level text',
            'Personal Journals',
            'Taped Texts, of grade-level texts',
            'Group Response with a White Board',
            'Reader-Writer-Speaker Response Triads',
            'Gallery Walk',
            'Mix and Match with Essay Direction Words',
            'Numbered Heads Together',
            'Question-Answer-Response (QAR) write, think and search with grade-level texts',
        ],
        '5755c5f62127240009000003': [
            'Extension of content-specific and sight word vocabulary, with careful attention to validate cultural and linguistic knowledge',
            'KWL Chart',
            'Pretest with a Partner',
            'Book Walk, with grade-level text',
            'Question-Answer-Response (QAR) strategy',
            'Line Ups to review',
            'Jig Saw Readings',
            'Language Experience Approach',
            'Interactive Reading Opportunities (Working in groups, students write down everything they know about a reading selection. Then they write three questions they want to have answered by the selection.)',
            'Vocabulary Journals that include L1 examples',
        ],
    };

    const bridgingStrategy = {
        '577d6906e21552000a000005': [
            'All strategies used for lower English fluency levels but with less scaffolding',
            'The same strategies used with English only students, scaffolding as necessary and with careful attention to validate cultural and linguistic knowledge',
        ],
        '577d68ff1f3023000b000000': [
            'All strategies used for lower English fluency levels but with less scaffolding',
            'The same strategies used with English only students, scaffolding as necessary and with careful attention to validate cultural and linguistic knowledge',
            'R.A.F.T. – incorporating writing into informational text (R - role of the writer; A - audience; F - format; T - topic beginning with a strong verb)',
        ],
        '577d68f6378fe5000b000003': [
            'All strategies used for lower English fluency levels but with less scaffolding.',
            'The same strategies used with English only students, scaffolding as necessary and with careful attention to validate cultural and linguistic knowledge',
            'Context clues',
            'Cornell Notes',
            'Character Trait Web',
            'Time line',
            '“What if...”',
        ],
        '577d6069378fe5000a000008': [
            'All strategies used with lower levels of fluency, with minimal scaffolding',
            'Strategies used with English only students, scaffolding as necessary and with careful attention to validate cultural and linguistic knowledge',
            'Explicit grammar instruction to address non-transferable grammar issues',
            'Highest grade-level sentence frames',
            'Using “Found Poem” to interpret, demonstrate or apply knowledge gained (Found poems take existing texts and refashion them, reorder them, and present them as poems. The literary equivalent of a collage, found poetry is often made from newspaper articles, street signs, graffiti, speeches, letters, or even other poems)',
        ],
        '5755c5fd2339f80009000000': [
            'All strategies used with lower levels of fluency, with minimal scaffolding and with careful attention to validate cultural and linguistic knowledge',
            'Focused questions to guide reading of grade-level material',
            'SQ2PRS, paired with Split Page Note Taking (Cornell Notes)',
            'Establish a Writers’ Circle - Invite students to discuss, read their work or hear their work read to members of the class. Opportunities to choose their best work and distinguish the best ideas provide a powerful opportunity to reflect on one’s work',
        ],
        '5755c5f62127240009000003': [
            'All strategies used with lower levels of fluency, with minimal scaffolding',
            'Strategies used with English only students, scaffolding as necessary and with careful attention to validate cultural and linguistic knowledge',
            'When possible, let students write or dictate their stories in their native language. This strategy gives students the opportunity to sequence and to think in greater detail. The stories or essays can then be transcribed into English for study, or students can work with the ELD teacher to do their own translations',
            'Study Guides for Independent Reading to help structure reaction to reading with specific prompts',
            'Use all strategies from previous levels with less scaffolding',
        ],
    };

    const emergingProduct = {
        '577d6906e21552000a000005': [
            'Original book covers, poetry, games, cartoons, murals/artwork, costumes, CD covers',
            'Power point presentations with scripts',
            'Original systems of classification for familiar objects',
            'Construction of conceptual models using realia, manipulatives or illustrations',
            'Scaffolded/scripted/structured presentations explaining any of the above products',
            'Respond to questions written at various cognitive levels on (a topic)',
            'Illustrate time lines',
            'Create Comic Strips with peers',
            'Create Advertisement Posters with peers',
        ],
        '577d68ff1f3023000b000000': [
            'Illustrated self-evaluations',
            'Surveys/charts paraphrased',
            'Recommendations by students',
            'Illustrated rating scales',
            'Illustrated value lines',
            'Posters of a character in a story including how he/she moves the plot of the story',
            'Venn diagram depicting similarities and differences of two or more characters',
            'Students generate and respond in simple, scaffolded connected narratives',
            'After using graphic organizers, students will produce a Synthesis of a story by combining, creating, designing, or predicting using sentence frames and illustrations',
        ],
        '577d68f6378fe5000b000003': [
            'Original book covers',
            'Poetry interpretations in L1',
            'Share skit performances',
            'Games created by students to support ideas',
            'Cartoons examine key ideas',
            'Sequencing parts of a process/story',
            'Matching illustrations of causes to effects',
            'Flowcharts showing critical steps/stages',
            'Graphs showing information',
        ],
        '577d6069378fe5000a000008': [
            'Collections related to topic',
            'Scaffolded interviews',
            'Models and dioramas',
            'Selection of items according to criteria',
            'Use of criteria (latitude & longitude) to complete a process (find a location on a map)',
            'Completion of graphic organizers',
            'Vocabulary Dictionary',
        ],
        '5755c5fd2339f80009000000': [
            'Show and tell',
            'Story problems',
            'Summaries',
            'Mathematical calculations',
            'Identification of parts on a drawing',
            'Drawings of processes or cycles',
            'Lists of comparisons',
            'Create storyboards',
            'Pantomimes/dramatizations',
            'Completion of graphic organizers',
            'Personal Dictionaries',
        ],
        '5755c5f62127240009000003': [
            'Brief, highly structured oral response',
            'Vocabulary charts with synonyms, antonyms, drawings, translations, and cognates',
            'Fact charts',
            'Lists by categories',
            'Recitations',
            'Highlighted readings',
            'Oral responses to questions',
            'Either/or and yes/no answers',
        ],
    };

    const expandingProduct = {
        '577d6906e21552000a000005': [
            'Create original book covers, poetry, skits, games, cartoons, murals/artwork, podcasts, CD covers',
            'Develop Power Point presentations',
            'Original systems of classification for academic topics',
            'Invent a new use for a familiar item',
            'Scaffolded/scripted/structured presentations explaining any of the above products',
        ],
        '577d68ff1f3023000b000000': [
            'Illustrate self-evaluations',
            'Surveys/charts',
            'Illustrate rating scales',
            'Illustrate value lines',
            'Write a letter to the editor',
            'Prepare and conduct a debate',
            'Write a persuasive speech arguing for or against with collaboration',
            'Create a booklet about five rules you see as important in school',
            'Form a panel to discuss viewpoints',
            'Evaluate the character’s actions in the story',
        ],
        '577d68f6378fe5000b000003': [
            'Rewrite stories',
            'Poetry interpretations',
            'Skit performances',
            'Games',
            'Sequencing parts of a process/story',
            'Illustrations of causes with extended texts',
            'Flowcharts showing critical steps/stages with extended texts',
            'Graphs showing information with extended texts',
            'Paraphrasing of important documents',
        ],
        '577d6069378fe5000a000008': [
            'Scaffolded presentations',
            'Role playing',
            'Interviews',
            'Scripted presentations',
            'Structured speeches',
            'Scrapbooks (about an area of study)',
            'Posters',
            'Illustrated time line, movie poster',
            'Comic strip',
            'Create an advertisement',
        ],
        '5755c5fd2339f80009000000': [
            'Paraphrasing brief passages or documentsScaffolded summaries',
            'Scaffolded written/oral explanations of solutions to problems',
            'Oral and written explanations of steps in a process or cycle',
            'Captioned drawings and illustrations',
            'Original skits',
            'Outline steps for writing a research report',
            'Outline steps for blogging',
            'Create storyboards with scripts',
        ],
        '5755c5f62127240009000003': [
            'Cloze retelling of a reading or lecture',
            'Completion of semantic mapping/ graphic organizers',
            'Cloze paragraphs with defined vocabulary word bank',
            'Student Personal Journals',
            'Quick Writes',
            'Written definitions of vocabulary that include synonyms, antonyms, roots, suffixes, prefixes, related and collocated words, and original, complex sentences, paragraphs, or essays using vocabulary in context',
        ],
    };

    const bridgingProduct = {
        '577d6906e21552000a000005': [
            'Write extended essays, research papers',
            'Original plays, computer games, simulations, movies',
            'Conduct chat room discussions',
            'Original dramatic presentations, musical compositions',
            'Develop web pages/podcasts',
            'Conduct an advertising campaign',
            'Propose a change in an organization (e.g., government) and create a plan with specific time lines',
        ],
        '577d68ff1f3023000b000000': [
            'Extend critiques of texts',
            'Self-evaluations of progress',
            'Performance reflections',
            'Write a letter of recommendation for a friend',
            'Complete Anticipation Guide',
            'Defend a stance in a debate',
            'Independently write a persuasive speech arguing for or against',
            'Write a letter of application for college',
        ],
        '577d68f6378fe5000b000003': [
            'Write analyses of concepts',
            'Formal oral presentations supported by power points, posters, graphic organizers, visuals, models, or realia',
            'Write structured lab reports',
            'Construct test items that are open-ended and support the development of the topic',
            'Research a topic and provide supporting evidence',
        ],
        '577d6069378fe5000a000008': [
            'Write paraphrases and summaries',
            'Write explanations of solutions to problems in new situations',
            'Write explanations of steps in a process or cycle in a new context',
            'Write explanations of drawings and illustrations',
            'Chat room discussions',
            'Write steps for creating analogies',
        ],
        '5755c5fd2339f80009000000': [
            'Paraphrases of extended text',
            'Explanations of solutions to problems',
            'Explanations of drawings and illustrations',
            'Chat room discussions',
            'Write a sequential paragraph which guides readers through a process or action to be performed.',
            'It’s very concise and uses formal, non-descriptive vocabulary accounting for subsequent actions or events',
            'Convert slides from Power Point to written text',
        ],
        '5755c5f62127240009000003': [
            'Oral and written retelling of parts of a reading or lecture',
            'ELs learn that these paragraphs are used to explain the meaning, origin and function of things, accounting for evidence as well as examples accordingly. They are used both in academic writing and fiction',
            'Develop test items with answers of chapters or unit topics',
        ],
    };

    let insertTextDebounce = false;

    $scope.onNavToggle = () => {
        $scope.isNavCollapseableHidden = !$scope.isNavCollapseableHidden;
    };

    $scope.onQuestionToggle = () => {
        $scope.isQuestionListActive = !$scope.isQuestionListActive;
    };

    const showProgress = (show, message) => {
        $timeout(() => {
            $scope.error = null;
            $scope.progress = null;

            if (show) {
                $scope.progress = message;
            }
        });
    };

    const showError = (show, message) => {
        $timeout(() => {
            $scope.error = null;
            $scope.progress = null;

            if (show) {
                $scope.error = message;

                if (message === addonFactory.API_CALL_ERROR.QUOTAERROR) {
                    $scope.enableReload = false;
                } else {
                    $scope.enableReload = true;
                }
            }
        });
    };

    const errorHandler = (error) => {
        const errorResp = addonFactory.errorHandler(error, $scope);
        showError(true, errorResp);
    };

    const setDOK = (data) => {
        $scope.unSortedDokList = [];
        $timeout(() => {
            for (let i = data.dropdown_values.length - 1; i >= 0; i -= 1) {
                $scope.unSortedDokList.push(data.dropdown_values[i]);
            }
        });
    };

    const setLanguageProficiency = (data) => {
        $timeout(() => {
            $scope.unSortedLangProfList = data.dropdown_values;
            $scope.sortingLangProf = ['Emerging English', 'Expanding English', 'Bridging English'];
        });
    };

    const setELAELDStandards = (data) => {
        $timeout(() => {
            $scope.unSortedELAELDStandardsList = data.dropdown_values;
            $scope.sortingELAELDStandards = ['All', 'Stories', 'Drama', 'Poetry', 'Informational Text'];
        });
    };

    const setTypeIdValue = (data) => {
        angular.forEach(data.dropdown_values, (value) => {
            if (value.title === 'Questions') {
                $scope.questionsId = value.id;
            } else if (value.title === 'Sentence Frames') {
                $scope.sentenceFrameId = value.id;
            }
        });
    };

    $scope.sortedLangProfList = () => {
        return (item) => {
            return $scope.sortingLangProf.find(k => item.title === k);
        };
    };

    $scope.sortedELAELDStandardList = () => {
        return (item) => {
            return $scope.sortingELAELDStandards.find(k => item.title === k);
        };
    };

    const setAudioPopoverTrigger = () => {
        // google.script.run.setAddonTooltipTrigger(false, null, $scope.serverToken);
    };

    const setQuestionSection = () => {
        $timeout(() => {
            $scope.questionList = $scope.currentQuestionSet.canvases;

            if ($scope.searchData != null) {
                const filteredDok = $scope.searchData[$scope.currentQueryData.dok];
                $scope.searchResultsQuestionIds = filteredDok[$scope.currentQueryData.langProf];
            }
        });
    };

    const setSentenceSection = () => {
        $timeout(() => {
            $scope.sentenceList = $scope.currentSentenceSet.canvases;

            if ($scope.searchData != null) {
                const filteredDok = $scope.searchData[$scope.currentQueryData.dok];
                $scope.searchResultsSentenceIds = filteredDok[$scope.currentQueryData.langProf];

                let questionSectionHasResults = false;
                let sentenceSectionHasResults = false;
                angular.forEach($scope.questionList, (value) => {
                    if (!questionSectionHasResults) {
                        questionSectionHasResults = $scope.searchResultsQuestionIds.includes(value.id);
                    }
                });

                angular.forEach($scope.sentenceList, (value) => {
                    if (!sentenceSectionHasResults) {
                        sentenceSectionHasResults = $scope.searchResultsSentenceIds.includes(value.id);
                    }
                });


                if ($scope.isQuestionListActive && !questionSectionHasResults) {
                    $scope.isQuestionListActive = false;
                }

                if (!$scope.isQuestionListActive && !sentenceSectionHasResults) {
                    $scope.isQuestionListActive = true;
                }
            }
        });
    };

    const setStategiesProductsSection = () => {

        const selectedLanguageProficiency = $scope.currentQueryData.langProf;

        $timeout(() => {

            if (selectedLanguageProficiency === '5755c6452471270009000000') {
                $scope.strategyList = expandingStrategy[$scope.currentQueryData.dok];
                $scope.productList = expandingProduct[$scope.currentQueryData.dok];
            } else if (selectedLanguageProficiency === '5755c62a78d6f5000b000000') {
                $scope.strategyList = emergingStrategy[$scope.currentQueryData.dok];
                $scope.productList = emergingProduct[$scope.currentQueryData.dok];
            } else if (selectedLanguageProficiency === '5755c63acc6abe000b000002') {
                $scope.strategyList = bridgingStrategy[$scope.currentQueryData.dok];
                $scope.productList = bridgingProduct[$scope.currentQueryData.dok];
            }
        });
    };

    const showDialog = (message) => {
        $scope.nameOfTheTool = message;
        alertDialog.open();
    };

    const insertQuestionSet = (type, value, audio, destIndex) => {
        DrawpService.addTextBoxToSlide(value).then((res) => {
            DrawpService.gATextBoxAddEvent(type, value.id, value.text, $scope.language, $scope.currentQueryData.dok, $scope.currentQueryData.langProf, $scope.currentQueryData.elaEldStandard, audio, null, $scope.initValueLanguage, $scope.initValueAudio, true, 3, $scope.subscription, $scope.serverToken);
        }).error((err) => {
            console.log(err);
        });
    };

    $scope.insertText = (value, type) => {

        $log.info('insertText', value, type);

        // const audio = elAudio.checked;

        if ($scope.subscription_days === null || $scope.subscription_days <= 0) {
            if (insertTextDebounce) {
                return;
            }

            setTimeout(() => {
                insertTextDebounce = false;
            }, 1000);

            insertTextDebounce = true;

            DrawpService.gATextBoxAddEvent(type, value.id, value.text, $scope.language, $scope.currentQueryData.dok,
                $scope.currentQueryData.langProf, $scope.currentQueryData.elaEldStandard, $scope.slideDialogData.audio, '',
                $scope.initValueLanguage, $scope.initValueAudio, false, 3, $scope.subscription, $scope.serverToken);
            showDialog('Language Scaffolding Tool (3 levels)');
        } else {
            DrawpService.addTextBoxToSlide(value.text).then((res) => {
                DrawpService.gATextBoxAddEvent(type, value.id, value.text, $scope.language, $scope.currentQueryData.dok, $scope.currentQueryData.langProf, $scope.currentQueryData.elaEldStandard, $scope.slideDialogData.audio, "", $scope.initValueLanguage, $scope.initValueAudio, true, 3, $scope.subscription, $scope.serverToken);
            }).catch((err) => {
                console.log(err);
            });
        }
    };

    // Drop Down Selected Item
    const selectElement = (value, type) => {
        if (type === 'dok') {
            const index = $scope.unSortedDokList.findIndex(x => x.id == value);
            setTimeout(() => {
                $scope.elBloomsLevel.selectedIndex = index;
                $scope.currentQueryData.dok = value;
            }, 1000);
        } else if (type === 'languageProficiency') {
            const index = $scope.unSortedLangProfList.findIndex(x => x.id === value);
            elLangProficiency.selectedIndex = index;
            setTimeout(() => {
                $scope.currentQueryData.langProf = value;
            }, 1000);
        }
    };

    $scope.determineListClass = (index, isLast, value, isQuestion) => {

        let isSearchResult = null;

        if (isQuestion) {
            isSearchResult = $scope.searchResultsQuestionIds.includes(value.id);
        } else {
            isSearchResult = $scope.searchResultsSentenceIds.includes(value.id);
        }

        if (isSearchResult) {
            if (index === 0) {
                return 'divider mdc-list-item search-result-first';
            } if (isLast) {
                return 'mdc-list-item search-result-last';
            }
            return 'divider mdc-list-item search-result';

        }
        if (!isLast) {
            return 'divider mdc-list-item';
        }
        return 'mdc-list-item';


    };

    const resetSearch = () => {
        $scope.searchErrorMessage = '';
        $scope.searchData = null;
        $scope.searchResultsQuestionIds = [];
        $scope.searchResultsSentenceIds = [];
        $scope.disabledDokList = [];
    };

    $scope.clearSearch = () => {
        $scope.searchQuery = '';
        resetSearch();
    };

    $scope.determineDokClass = (dokId, index) => {
        if (index === 0) {
            if ($scope.disabledDokList.includes(dokId)) {
                angular.element(`#dok-popover-${dokId}`).popover({
                    container: 'body',
                    placement: 'top',
                    trigger: 'hover',
                    content: 'No results that match your search'
                });
                return 'mdc-list-item mdc-list-item--selected mdc-list-item--disabled';
            }
            angular.element(`#dok-popover-${dokId}`).popover('dispose');
            return 'mdc-list-item mdc-list-item--selected';

        }
        if ($scope.disabledDokList.includes(dokId)) {
            angular.element(`#dok-popover-${dokId}`).popover({
                container: 'body',
                placement: 'top',
                trigger: 'hover',
                content: 'No results that match your search'
            });
            return 'mdc-list-item mdc-list-item--disabled';
        }
        angular.element(`#dok-popover-${dokId}`).popover('dispose');
        return 'mdc-list-item';


    };

    $scope.handleDefaultValueEvent = () => {
        // google.script.run.withSuccessHandler(() => {
        //     $log.info('setAddonDefaults success.');
        // }).setAddonDefaults($scope.language, elAudio.checked, $scope.initValuePlaceholder, $scope.serverToken);
    };

    $scope.onEnterPressed = (event) => {
        if (event.keyCode === 13) {
            // Cancel the default action, if needed
            event.preventDefault();
            // Trigger the button element with a click
            $scope.searchFunction();
        }
    };

    $scope.onPurchaseClick = () => {
        if (!DrawpService.isLoggedIn()) {
            $scope.loginDialogMessage = 'Please login to purchase this tool.';
            $scope.isLoginDialogOpen = true;
        } else {
            DrawpService.gAPurchaseButtonSelectedEvent(3, $scope.language, null, null, $scope.serverToken);
            $state.go('payment', {
                tool: "3",
                language: $scope.language,
                data1: null,
                data2: null
            });
        }
    };

    $scope.showSubscriptionDetail = () => {
        showProgress(true, progressText);
        // google.script.run.withSuccessHandler((text) => {
        //     if (text === null) {
        //         showProgress(true, 'There was an error while loading this page', true, false);
        //     } else {
        //         const data = JSON.parse(text);
        //         $scope.is_renew_toggle_available = true;
        //         $scope.cancel_at_period_end = false;
        //         $scope.subscriptionDaysLeft = null;
        //         $scope.subscriptionExpiryDate = null;

        //         if (data.cancel_at_period_end != null) {
        //             $scope.cancel_at_period_end = !data.cancel_at_period_end;
        //         } else {
        //             $scope.is_renew_toggle_available = false;
        //         }

        //         if (data.subscription_due_on != null) {
        //             $scope.subscriptionDaysLeft = data.subscription_days_left;

        //             const date = new Date(data.subscription_due_on.replace(' ', 'T'));
        //             const months = ['Jan', 'Feb', 'Mar', 'April', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
        //             const ampm = date.getHours() >= 12 ? 'pm' : 'am';

        //             let minutes = date.getMinutes();
        //             if (minutes < 10) {
        //                 minutes = `0${minutes}`;
        //             }
        //             $timeout(() => {
        //                 $scope.subscriptionExpiryDate = `${months[date.getMonth()]} ${date.getDate().toString()}, ${date.getFullYear().toString()} at ${date.getHours()}:${minutes} ${ampm}`;
        //             });
        //         }

        //         showProgress(false, '', false, false);
        //         subscriptionInfoDialog.open();

        //         if ($scope.is_renew_toggle_available) {
        //             elementCancelSub = mdc.switchControl.MDCSwitch.attachTo(document.querySelector('#cancel-subscription-switch'));
        //             elementCancelSub.checked = $scope.cancel_at_period_end;
        //         }
        //     }
        // }).withFailureHandler(errorHandler).getSubscriptionData($scope.toolId, $scope.serverToken);
    };

    $scope.getDokTitle = (index) => {
        return $scope.dokLabels[index];
    };

    $scope.cancel_at_period_end_change = () => {
        // google.script.run.withSuccessHandler(() => {
        //     $log.info('renewSubscriptionToggle success.');
        // }).renewSubscriptionToggle(elementCancelSub.checked, $scope.toolId, $scope.serverToken);
    };

    $scope.snackBarUtil = (show, messageText, actionText) => {
        $scope.launchSnackBar(messageText, actionText, show);
    };

    $scope.reloadCurrentPage = () => {
        $state.go($state.current.name, {}, { reload: true });
    };

    const loadLessonPlan = () => {

        // Since we are changing the values for the drop down programatically the on change of the drop downs will trigger the 
        // loadLessonPlan method, there might be simiultaneous requests thus to prevent that I have used a isSearchFilteringRunning key to 
        // know when the api call should and should not happen
        if ($scope.isSearchFilteringRunning) {
            return;
        }

        let searchTagsQuestions = [];
        let searchTagsSentences = [];

        // console.log(element_areaOfFocus.value);
        // console.log(element_bloomsLevel.value);
        // console.log(element_languageProficiency.value);

        $scope.currentQueryData.dok = $scope.elBloomsLevel.value;
        $scope.currentQueryData.langProf = elLangProficiency.value;
        $scope.currentQueryData.elaEldStandard = elAreaOfFocus.value;

        if (elAreaOfFocus.value === 'all') {
            searchTagsQuestions = [
                $scope.elBloomsLevel.value,
                elLangProficiency.value,
                $scope.questionsId,
            ];

            searchTagsSentences = [
                $scope.elBloomsLevel.value,
                elLangProficiency.value,
                $scope.sentenceFrameId,
            ];
        } else {
            searchTagsQuestions = [
                elAreaOfFocus.value,
                $scope.elBloomsLevel.value,
                elLangProficiency.value,
                $scope.questionsId,
            ];

            searchTagsSentences = [
                elAreaOfFocus.value,
                $scope.elBloomsLevel.value,
                elLangProficiency.value,
                $scope.sentenceFrameId,
            ];
        }

        DrawpService.getBundleLessonPlan($scope.bundleId, searchTagsQuestions, searchTagsSentences, $scope.language, $scope.serverToken).then((response) => {
            $scope.currentQuestionSet = response[0];
            $scope.currentSentenceSet = response[1];

            // $log.info($scope.currentQuestionSet);
            // $log.info($scope.currentSentenceSet);

            // Temp logic for Desert Sands - START
            if ($scope.userEmail.includes('desertsands.us')) {
                if (searchTagsQuestions.includes('577d68f6378fe5000b000003') && searchTagsQuestions.includes('5755c6452471270009000000') && $scope.language === 'en') {
                    $scope.currentQuestionSet.push({
                        'text_sticker_id': '577c4cea1696da0018000015_1',
                        'lesson_id': '577edf6cf18d220009000007',
                        'language': 'en',
                        'url': '',
                        'text': 'What claim does the author make about the relationship between _____?',
                        'audio': '',
                        'id': '577edd27e31b9f0009000000_1',
                        'audio_sticker_id': '5aabaa8401a03f6b1e190f23_1'
                    });
                }

                if (searchTagsQuestions.includes('577d68f6378fe5000b000003') && searchTagsQuestions.includes('5755c6452471270009000000') && $scope.language === 'es') {
                    $scope.currentQuestionSet.push({
                        'text_sticker_id': '577c4cea1696da0018000015_1',
                        'lesson_id': '577edf6cf18d220009000007',
                        'language': 'es',
                        'url': '',
                        'text': '¿Qué afirmación hace el autor sobre la relación entre _____?',
                        'audio': '',
                        'id': '577edd27e31b9f0009000000_1',
                        'audio_sticker_id': '5aabaa8401a03f6b1e190f23_1'
                    });
                }

                if (searchTagsQuestions.includes('577d68ff1f3023000b000000') && searchTagsQuestions.includes('5755c63acc6abe000b000002') && $scope.language === 'en') {
                    $scope.currentQuestionSet.push({
                        'text_sticker_id': '577c4cea1696da0018000015_1',
                        'lesson_id': '577edf6cf18d220009000007',
                        'language': 'en',
                        'url': '',
                        'text': 'How does the author use _____ to advance their purpose?',
                        'audio': '',
                        'id': '577edd27e31b9f0009000000_1',
                        'audio_sticker_id': '5aabaa8401a03f6b1e190f23_1'
                    });
                }

                if (searchTagsQuestions.includes('577d68ff1f3023000b000000') && searchTagsQuestions.includes('5755c63acc6abe000b000002') && $scope.language === 'es') {
                    $scope.currentQuestionSet.push({
                        'text_sticker_id': '577c4cea1696da0018000015_1',
                        'lesson_id': '577edf6cf18d220009000007',
                        'language': 'es',
                        'url': '',
                        'text': '¿Cómo utiliza el autor __ para promover su propósito?',
                        'audio': '',
                        'id': '577edd27e31b9f0009000000_1',
                        'audio_sticker_id': '5aabaa8401a03f6b1e190f23_1'
                    });
                }
            }
            // Temp logic for Desert Sands - END

            setQuestionSection();
            setSentenceSection();
            setStategiesProductsSection();

            showProgress(false, '', false, false);
        }).catch((error) => {
            console.log(error);
            // if (response === null) {
            showError(true, 'There was an error while loading this page');
            // } else if (response === 401) {
            //     showError(
            //         true,
            //         'This Drawp Add-On tool is not available for your account. You can explore the tool 30 days for free by <a target="blank" href="https://app.drawpforschool.com/teacher/search-school/google/">signing up</a>. Contact <a href = "mailto: sales@drawpforschool.com">sales@drawpforschool.com</a> for more details or visit <a target="blank" href="https://drawpforschool.com/#pricing">pricing</a>.'
            //     );
            // }
        });
    };

    $scope.searchFunction = () => {

        if ($scope.searchQuery.trim().length === 0) {
            return;
        }

        showProgress(true, progressText, false, true);

        $scope.searchErrorMessage = '';

        let selectedElaEldStandards = $scope.currentQueryData.elaEldStandard;
        if (selectedElaEldStandards === 'all') {
            selectedElaEldStandards = null;
        }

        DrawpService.lvl3Search($scope.searchQuery, selectedElaEldStandards, $scope.language, $scope.serverToken).then((text) => {
            const data = text.data;
            $scope.searchData = data.data;

            $scope.searchErrorMessage = '';

            if (data.result_found === null) {
                $scope.searchData = null;
                $scope.searchResultsQuestionIds = [];
                $scope.searchResultsSentenceIds = [];

                $scope.searchErrorMessage = 'No results found';
                setQuestionSection();
                setSentenceSection();
                showProgress(false, '', false, false);
            } else {
                $scope.searchErrorMessage = '';
                $scope.isSearchFilteringRunning = true;

                // check if current dok and ell has results
                const hasCurrentValues =
                    $scope.searchData[$scope.currentQueryData.dok][$scope.currentQueryData.langProf];

                if (Object.keys(hasCurrentValues).length === 0) {
                    let hasEmergingValues = {};
                    let hasExpandingValues = {};

                    if (Object.keys(data.result_found).length > 0) {
                        selectElement(data.result_found.dok, 'dok');

                        if ($scope.searchData[data.result_found.dok]['5755c62a78d6f5000b000000']) {
                            hasEmergingValues =
                                $scope.searchData[data.result_found.dok]['5755c62a78d6f5000b000000'];
                        }

                        if ($scope.searchData[data.result_found.dok]['5755c6452471270009000000']) {
                            hasExpandingValues = $scope.searchData[data.result_found.dok]['5755c6452471270009000000'];
                        }
                    }

                    if (Object.keys(hasEmergingValues).length > 0) {
                        selectElement('5755c62a78d6f5000b000000', 'languageProficiency');
                    } else if (Object.keys(hasExpandingValues).length > 0) {
                        selectElement('5755c6452471270009000000', 'languageProficiency');
                    } else {
                        selectElement('5755c63acc6abe000b000002', 'languageProficiency');
                    }
                }

                // Disable DOK if no results available
                $scope.disabledDokList = [];
                angular.forEach($scope.searchData, (dok, dokkey) => {
                    let resultCountInsideDok = 0;

                    angular.forEach($scope.searchData[dokkey], (ell, ellkey) => {
                        resultCountInsideDok += Object.keys($scope.searchData[dokkey][ellkey]).length;
                    });

                    if (resultCountInsideDok < 1) {
                        $scope.disabledDokList.push(dokkey);
                    } else if ($scope.disabledDokList.includes(dokkey)) {
                        $scope.disabledDokList.pop();
                    }
                });

                $scope.isSearchFilteringRunning = false;
                loadLessonPlan();
            }
        }).catch((error) => {
            console.log(error);
            // if (text === null) {
            showProgress(true, 'There was an error while loading this page', true, false);
            // } else if (text === 401) {
            //     showProgress(
            //         true,
            //         'This Drawp Add-On tool is not available for your account. You can explore the tool 30 days for free by <a target="blank" href="https://app.drawpforschool.com/teacher/signup">signing up</a>. Contact <a href = "mailto: sales@drawpforschool.com">sales@drawpforschool.com</a> for more details or visit <a target="blank" href="https://drawpforschool.com/#pricing">pricing</a>.',
            //         false,
            //         false
            //     );
            // } 
        });
    };

    $scope.handleLanguageChangeEvent = (language) => {
        $scope.isNavCollapseableHidden = false;
        showProgress(true, 'Processing language change...', false, true);
        // google.script.run
        //     .withSuccessHandler((text) => {
        //         if (text != null) {
        //             const languageData = JSON.parse(text);
        //             $scope.language = languageData.user.language;
        //             $scope.clearSearch();
        //             loadLessonPlan();
        //         }
        //     })
        //     .withFailureHandler((error) => {
        //         $log.error(error);
        $scope.language = language;
        $scope.clearSearch();
        loadLessonPlan();
        //     })
        //     .setAddonDefaults(language, elAudio.checked, $scope.initValuePlaceholder, $scope.serverToken);
    };

    const initSelectFieldListeners = () => {
        elAreaOfFocus = mdc.select.MDCSelect.attachTo(document.querySelector('#area-of-focus'));
        elLangProficiency = mdc.select.MDCSelect.attachTo(document.querySelector('#language-proficiency'));
        $scope.elBloomsLevel = mdc.select.MDCSelect.attachTo(document.querySelector('#blooms-level'));
        elLanguage = mdc.select.MDCSelect.attachTo(document.querySelector('#language'));

        $scope.elBloomsLevel.selectedIndex = 0;
        elLangProficiency.selectedIndex = 0;
        elAreaOfFocus.selectedIndex = 0;

        if ($scope.language === 'en') {
            elLanguage.selectedIndex = 0;
        } else {
            elLanguage.selectedIndex = 1;
        }

        elAreaOfFocus.listen('MDCSelect:change', () => {
            // console.log(`element_areaOfFocus ${element_areaOfFocus.selectedIndex} with value "${element_areaOfFocus.value}"`);

            if ($scope.currentQueryData.dok === $scope.elBloomsLevel.value &&
                $scope.currentQueryData.langProf === elLangProficiency.value &&
                $scope.currentQueryData.elaEldStandard === elAreaOfFocus.value) {
                // Do nothing
            } else {
                loadLessonPlan();
            }
        });

        elLangProficiency.listen('MDCSelect:change', () => {
            // console.log(`element_languageProficiency ${element_languageProficiency.selectedIndex} with value "${element_languageProficiency.value}"`);

            if ($scope.currentQueryData.dok === $scope.elBloomsLevel.value &&
                $scope.currentQueryData.langProf === elLangProficiency.value &&
                $scope.currentQueryData.elaEldStandard === elAreaOfFocus.value) {
                // Do nothing
            } else {
                loadLessonPlan();
            }
        });

        $scope.elBloomsLevel.listen('MDCSelect:change', () => {
            // console.log(`element_bloomsLevel ${element_bloomsLevel.selectedIndex} with value "${element_bloomsLevel.value}"`);
            $scope.$apply();

            const selectedDok = $scope.elBloomsLevel.value;

            if ($scope.searchData != null) {
                // check if current dok and ell has results
                const hasCurrentValues = $scope.searchData[selectedDok][$scope.currentQueryData.langProf];

                if (Object.keys(hasCurrentValues).length === 0) {
                    const hasEmergingValues = $scope.searchData[selectedDok]['5755c62a78d6f5000b000000'];
                    const hasExpandingValues = $scope.searchData[selectedDok]['5755c6452471270009000000'];

                    if (Object.keys(hasEmergingValues).length > 0) {
                        selectElement('5755c62a78d6f5000b000000', 'languageProficiency');
                    } else if (Object.keys(hasExpandingValues).length > 0) {
                        selectElement('5755c6452471270009000000', 'languageProficiency');
                    } else {
                        selectElement('5755c63acc6abe000b000002', 'languageProficiency');
                    }
                }
            }

            if ($scope.currentQueryData.dok === $scope.elBloomsLevel.value &&
                $scope.currentQueryData.langProf === elLangProficiency.value &&
                $scope.currentQueryData.elaEldStandard === elAreaOfFocus.value) {
                // Do nothing
            } else {
                loadLessonPlan();
            }
        });

        elLanguage.listen('MDCSelect:change', () => {
            showProgress(true, 'Processing language change...');
            $scope.language = elLanguage.value;
            $scope.clearSearch();
            $scope.handleDefaultValueEvent();

            $timeout(() => {
                $scope.sentenceList = [];
                $scope.questionList = [];
            });

            $timeout(() => {
                loadLessonPlan();
            }, 100);
        });

        if ($scope.audioToolTip) {
            angular.element('#audio-popover').popover('show');
            setAudioPopoverTrigger();
        }

        if ($scope.subscription_days === null || $scope.subscription_days <= 0) {
            elInputSearch.disabled = true;
            elAreaOfFocus.disabled = true;
            elLangProficiency.disabled = true;
            $scope.elBloomsLevel.disabled = true;
            // element_language.disabled = true;
        } else {
            elInputSearch.disabled = false;
            elAreaOfFocus.disabled = false;
            elLangProficiency.disabled = false;
            $scope.elBloomsLevel.disabled = false;
        }
        loadLessonPlan();
    };

    const getLoginSuccess = () => {
        $scope.language = $scope.formData.defaults.language;
        $scope.audio = $scope.formData.defaults.audio;
        $scope.audioToolTip = $scope.formData.defaults.language_scaffold_tooltip;

        $scope.initValueLanguage = $scope.formData.defaults.language;
        $scope.initValuePlaceholder = $scope.formData.defaults.placeholder;
        $scope.initValueAudio = $scope.formData.defaults.audio;

        // if ($scope.audio) {
        //     elAudio.checked = true;
        // } else {
        //     elAudio.checked = false;
        // }

        angular.forEach($scope.formData.filters, (value) => {
            $scope.bundleId = value.bundle_id;
            if (value.deleted === false) {
                if (value.title === 'Depth of Knowledge') {
                    setDOK(value);
                } else if (value.title === 'Language Proficiency') {
                    setLanguageProficiency(value);
                } else if (value.title === 'California ELA ELD Framework') {
                    setELAELDStandards(value);
                } else if (value.title === 'Type') {
                    setTypeIdValue(value);
                }
            }
        });

        showProgress(false, '');
        $timeout(() => {
            initSelectFieldListeners();
        }, 100);
    };

    const init = () => {
        showProgress(true, progressText);
        DrawpService.getLvl3Filters("").then((response) => {
            $scope.formData = response.data;
            $scope.subscription_days = $scope.formData.subscription_expired;
            $scope.subscription = $scope.subscription_days != null && $scope.subscription_days > 0;

            DrawpService.gAPageview('language-scaffolding-tool-ca', 'Fill-in-the-Blank Frames', 3, $scope.subscription, addonFactory.getActiveAccountEmail(), $scope.serverToken);

            if (!$scope.subscription) {
                angular.element('#search-popover').popover({
                    container: 'body',
                    placement: 'top',
                    trigger: 'hover',
                    content: 'Not available with your subscription'
                });

                angular.element('#area-of-focus-popover').popover({
                    container: 'body',
                    placement: 'top',
                    trigger: 'hover',
                    content: 'Not available with your subscription'
                });

                angular.element('#lang-prof-popover').popover({
                    container: 'body',
                    placement: 'top',
                    trigger: 'hover',
                    content: 'Not available with your subscription'
                });

                angular.element('#dok-popover').popover({
                    container: 'body',
                    placement: 'top',
                    trigger: 'hover',
                    content: 'Not available with your subscription'
                });
            } else {
                angular.element('#search-popover').popover('hide');
                angular.element('#area-of-focus-popover').popover('hide');
                angular.element('#lang-prof-popover').popover('hide');
                angular.element('#dok-popover').popover('hide');
            }
            // Avoid completing load if state has changed
            if ($state.current.name !== 'scaffoldingLevel3') return;
            getLoginSuccess();
        }).catch((error) => {
            // if (text === null) {
            showError(true, 'There was an error while loading this page');
            // } else if (text === 401) {
            //     showError(
            //         true,
            //         `This Drawp Add-On tool is not available for your account. You can explore the tool 30 days for free by 
            //                     <a target="blank"href="${serverUrl}teacher/search-school/google/">signing up</a>. Contact 
            //                     <a href = "mailto: sales@drawpforschool.com">sales@drawpforschool.com</a> for more details or visit 
            //                     <a target="blank" href="${serverUrl}#pricing">pricing</a>.`);
            // }
        });
    };

    $scope.reload = () => {
        init();
    };

    angular.element(document).ready(() => {
        // $scope.userEmail = document.getElementById('userEmail').textContent.trim();
        // $scope.serverToken = document.getElementById('serverToken').textContent.trim();
        // presentationId = document.getElementById('presentationId').textContent.trim();

        // const multiAccount = document.getElementById('multiAccount').textContent.trim();

        // $timeout(() => {
        //     $scope.alertMultiAccount = multiAccount === 'true';
        // });

        alertDialog = mdc.dialog.MDCDialog.attachTo(document.querySelector('#alert_dialog'));

        // subscriptionInfoDialog = mdc.dialog.MDCDialog.attachTo(document.querySelector('#subscription_info_dialog'));

        angular.element('#audio-popover').popover({
            container: 'body',
            placement: 'top',
            trigger: 'click focus',
            html: true,
            title: 'Human recorded audio <a href="javascript:void(0);" class="close dfs-addon-popover-close" data-dismiss="alert">&times;</a>',
            content: '<div class="media"><div class="media-body"><p>Human recorded audio will be linked to the frames when this switch is ON. You can use the switch to adjust this setting according to your preferences.</p></div></div>'
        });

        angular.element(document).on('click', '.popover .close', () => {
            angular.element('#audio-popover').popover('hide');
            angular.element('#audio-popover').popover('disable');
        });

        angular.element(document).click(() => {
            angular.element('#audio-popover').popover('hide');
            angular.element('#audio-popover').popover('disable');
        });

        elInputSearch = mdc.textField.MDCTextField.attachTo(document.querySelector('#search-field'));

        // elAudio = mdc.switchControl.MDCSwitch.attachTo(document.querySelector('#audio-switch'));
        // elAudio.checked = true;

        mdc.list.MDCList.attachTo(document.querySelector('.mdc-list'));

        // getServerUrl();
        init();
    });

    $scope.onSlideSelected = (destIndex, totalSlides) => {
        insertQuestionSet($scope.slideDialogData.type, $scope.slideDialogData.value, $scope.slideDialogData.audio, destIndex);
        $scope.hideSelectSlideDialog();
    };
}